import script from "./LayoutView.vue?vue&type=script&setup=true&lang=js"
export * from "./LayoutView.vue?vue&type=script&setup=true&lang=js"

import "./LayoutView.vue?vue&type=style&index=0&id=119577d0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-119577d0"]])

export default __exports__